import { Outlet } from "react-router-dom"
import { Box } from "@mui/material"

/**
 * Thin layout shared by the settings and account-settings route trees. The individual pages
 * (App Settings, Personal Profile, Accounts, Linked Devices) are now reached
 * as distinct sidebar items across the App and Personal settings categories,
 * so this no longer renders tabs. Each child page owns its own page title.
 */
const GeneralSettings = () => {
    return (
        <Box>
            <Outlet />
        </Box>
    )
}

export default GeneralSettings
